import React from 'react';
import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormatAlignCenter from '@mui/icons-material/FormatAlignCenter';
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRight from '@mui/icons-material/FormatAlignRight';
import ButtonGroup from '@mui/material/ButtonGroup';
import { connect } from 'react-redux'

import { align as alignAction } from '../../actions';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(0.5),
  }
}));

const Align = ({content, onAlign}) => {
  const classes = useStyles();

  const handleChange = (alignValue) => {
    onAlign(content.id, alignValue);
  }

  return (
    <ButtonGroup orientation="vertical" aria-label="outlined primary button group">
      <Tooltip title="Align left">
        <IconButton className={classes.button} aria-label="Align left" onClick={() => handleChange('left')}><FormatAlignLeft/></IconButton>
      </Tooltip>
      <Tooltip title="Align center">
        <IconButton className={classes.button} aria-label="Align center" onClick={() => handleChange('center')}><FormatAlignCenter/></IconButton>
      </Tooltip>
      <Tooltip title="Align right">
        <IconButton className={classes.button} aria-label="Align right" onClick={() => handleChange('right')}><FormatAlignRight/></IconButton>
      </Tooltip>
    </ButtonGroup>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
      onAlign: (rowId, align) => {
          dispatch(alignAction({ rowId, align }));
      }
  }
}

export default connect(
  null,
  mapDispatchToProps
)(Align);